// 정적 블로그 글 (기존 콘텐츠 - API 글이 없을 때 폴백)
export const STATIC_POSTS_LIST = [
  {
    id: 'static-1',
    slug: 'static-1',
    title: '로또 번호 선택의 과학: 통계로 보는 당첨 패턴',
    excerpt: '1,200회 이상의 로또 추첨 데이터를 분석하여 발견한 흥미로운 패턴들을 소개합니다.',
    published_at: '2026-02-15',
    category: '로또 분석',
    emoji: '📊'
  },
  {
    id: 'static-2',
    slug: 'static-2',
    title: '행운의 숫자와 심리학: 왜 우리는 특정 숫자를 선호할까?',
    excerpt: '사람들이 선호하는 행운의 숫자에는 문화적, 심리적 배경이 있습니다.',
    published_at: '2026-02-12',
    category: '운세 이야기',
    emoji: '🔢'
  },
  {
    id: 'static-3',
    slug: 'static-3',
    title: 'AI가 예측하는 로또 번호, 과연 효과가 있을까?',
    excerpt: 'GPT와 머신러닝을 활용한 로또 번호 생성의 원리와 한계를 알아봅니다.',
    published_at: '2026-02-10',
    category: '기술',
    emoji: '🤖'
  },
  {
    id: 'static-4',
    slug: 'static-4',
    title: '12별자리와 행운의 상관관계',
    excerpt: '별자리마다 선호하는 숫자와 색깔이 다릅니다. 점성술과 운세의 관점에서 본 행운의 요소들.',
    published_at: '2026-02-08',
    category: '운세 이야기',
    emoji: '♈'
  },
  {
    id: 'static-5',
    slug: 'static-5',
    title: '로또 당첨자들의 공통점: 실제 사례 연구',
    excerpt: '로또 고액 당첨자들의 인터뷰와 연구를 바탕으로 발견한 흥미로운 공통점들.',
    published_at: '2026-02-05',
    category: '로또 분석',
    emoji: '💰'
  },
  {
    id: 'static-6',
    slug: 'static-6',
    title: '타로 카드 입문: 메이저 아르카나 완벽 가이드',
    excerpt: '타로 카드 22장의 의미와 해석 방법을 초보자도 쉽게 이해할 수 있도록 설명합니다.',
    published_at: '2026-02-01',
    category: '운세 이야기',
    emoji: '🃏'
  }
];

export const STATIC_POSTS_DETAIL = {
  'static-1': {
    title: '로또 번호 선택의 과학: 통계로 보는 당첨 패턴',
    date: '2026-02-15',
    category: '로또 분석',
    content: `# 로또 번호 선택의 과학

1,200회가 넘는 로또 추첨 데이터를 분석한 결과, 흥미로운 패턴들을 발견할 수 있었습니다.

## 1. 번호 출현 빈도의 분산

모든 번호는 이론적으로 동일한 확률(1/45)로 추첨되어야 하지만, 실제 데이터를 보면 약간의 편차가 존재합니다.
가장 많이 나온 번호와 가장 적게 나온 번호의 차이는 약 30-40회 정도입니다.

## 2. 연속 번호의 출현

놀랍게도 당첨 번호 중 **연속된 번호가 포함될 확률은 약 60%**입니다.
예를 들어 [12, 13]이나 [28, 29, 30]처럼 연속된 숫자가 함께 나오는 경우가 상당히 많습니다.

## 3. 홀짝 비율

가장 흔한 조합은 **홀수 3개 + 짝수 3개** 조합입니다.
전체 홀수 또는 전체 짝수로 당첨된 경우는 역대 5회 미만입니다.

## 결론

통계적 패턴은 흥미롭지만, **로또는 여전히 무작위 게임**입니다.
이러한 패턴들은 참고용으로만 활용하시고, 책임감 있는 구매를 권장합니다.`
  },
  'static-2': {
    title: '행운의 숫자와 심리학: 왜 우리는 특정 숫자를 선호할까?',
    date: '2026-02-12',
    category: '운세 이야기',
    content: `# 행운의 숫자와 심리학

## 문화적 배경

### 한국에서의 행운의 숫자
- **3**: 삼세번, 삼신할미 등 긍정적 의미
- **7**: 서양 문화의 영향으로 행운의 숫자로 인식
- **8**: 발음이 '팔(發)'과 유사하여 발전, 번영의 의미

### 피하는 숫자
- **4**: 죽음(死)과 발음이 같아 기피

## 심리학적 분석

### 확증 편향
사람들은 자신이 좋아하는 숫자가 실제로 행운을 가져온다고 믿는 경향이 있습니다.

### 생일 효과
자신이나 가족의 생일 숫자를 선호하는 경향 - 로또 구매자의 70% 이상이 생일 숫자 포함

## 결론

행운의 숫자는 **심리적 안정감**과 **긍정적 마인드**를 제공합니다.
과학적 근거보다는 자신감과 희망을 주는 도구로 활용하세요!`
  }
};
